import { useEffect, useState } from 'react';

export function use100vh() {
  const [height, setHeight] = useState(measureHeight);

  useEffect(() => {
    function setMeasuredHeight() {
      const measuredHeight = measureHeight();
      setHeight(measuredHeight);
    }

    window.addEventListener('resize', setMeasuredHeight);
    return () => window.removeEventListener('resize', setMeasuredHeight);
  });
  return `${height}px`;
}

export function measureHeight() {
  return document.documentElement?.clientHeight || window.innerHeight;
}
